<template>
  <div>
    <div class="col s12 center" id="app">
      <form action="#">
        <v-card v-if="isSending == false && wasUploaded">
          <!--v-if=""-->
          <v-card-title
            ><v-icon color="#00c861">mdi-check-cicle</v-icon> Änderung war
            erfolgreich</v-card-title
          >
          <v-card-text>
            <p>
              Sie haben die Daten erfolgreich aktuellisiert. Möchten Sie ein
              Team aktiv über die Änderung informieren?
            </p>

            <v-list flat>
              <v-subheader>Push Nachrichten - (noch nicht vollständig implementiert)</v-subheader>
              <v-list-item-group color="primary">
                <v-list-item v-for="item in teams" :key="item" @click="sendPush(item)">
                  <v-list-item-icon>
                    <v-icon>mdi-bell-ring</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      >Direkte Push Nachricht an: <b>{{ item }}</b></v-list-item-title
                    >
                    <p v-if="pushRecipients">Nachricht gesendet an: {{JSON.stringify(pushRecipients,null,2)}}</p>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>

            <v-list flat>
              <v-subheader>Chaträume</v-subheader>
              <v-list-item-group color="primary">
                <v-list-item v-for="rooms in chatRooms" :key="rooms.key" @click="sendChat(rooms.key)">
                  <v-list-item-icon>
                    <v-icon>mdi-chat</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title 
                      >Nachricht in Chat:
                      {{ rooms.roomname }}</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn @click="wasUploaded = undefined"><v-icon left>mdi-upload</v-icon>Weitere Datei hochladen</v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-if="isSending == true">
          <v-card-text>
            <div class="text-center">
              <v-progress-circular size="200" color="blue" indeterminate
                >Sende Nachricht</v-progress-circular>
              
            </div>
          </v-card-text>
        </v-card>
        <div class="row" v-if="!wasUploaded">
          <div class="col s12 m12">
            <div class="card" v-if="rawdata == undefined">
              <!-- Show file selector -->
              <fileselector
                template="ep_landshut"
                @selected="onFileSelected"
                @reset="reset"
              ></fileselector>
            </div>
          </div>
        </div>
      </form>
    </div>
    <uploadpreview
      :file="$router.currentRoute.path.substring(1)"
      :data="rawdata"
      v-if="rawdata"
      :key="uploadTime"
      @uploaded="reset"
    ></uploadpreview>
  </div>
</template>


<script>
import uploadpreview from "../components/EpLandshutPreview";
import fileselector from "../components/FileSelector";
import axios from "axios";
import configuration from "../../configuration.json";

export default {
  components: {
    uploadpreview,
    fileselector,
  },
  data() {
    return {
      rawdata: undefined,
      shift: 0,
      uploadTime: "new",
      teams: [],
      wasUploaded: false,
      allEmployees: [],
      chatRooms: [],
      isSending: false,
      pushRecipients: undefined,
    };
  },
  async mounted() {
    let url = `${configuration.teamSearchUrl}?department=${this.$store.getters.department}&page=0&size=100`;
    this.teams = [];

    let team = await axios.get(url);
    this.allEmployees = team.data;

    // eslint-disable-next-line no-console
    console.log(JSON.stringify(team));

    await team.data.forEach((member) => {
      if (!this.teams.includes(member.department)) {
        this.teams.push(member.department);
      }
    });

    let chats = await axios.get(
      `${configuration.chatEndpoint}getFavoriteChatRooms.xsjs`
    );
    this.chatRooms = chats.data;

    // eslint-disable-next-line no-console
    console.log(this.chatRooms);
  },
  methods: {
    // set rawdata and orgunit on file select
    onFileSelected: function (org, data) {
      this.rawdata = data;
      this.uploadTime = "" + new Date();

      // eslint-disable-next-line no-console
      console.log(this.rawdata);
    },
    // set shift
    setShift: function (shift) {
      this.shift = shift;
    },
    // reset data
    reset: function () {
      this.rawdata = undefined;
      this.shift = null;
      this.wasUploaded = true;
    },
    sendPush: async function (item) {
      this.isSending = true;
      let rcps = {users: []};
      this.pushRecipients = [];

      await this.allEmployees.forEach((member) => {
        if (member.department == item) {
          rcps.users.push(member.accountName.toUpperCase());
          this.pushRecipients.push(member.displayName);
        }
      });
      //alert("Das System würde an diese Mitarbeiter senden: " + JSON.stringify(rcps));
      await axios.post(configuration.pushEndpoint, JSON.stringify(rcps));
      this.isSending = false;
    },
    sendChat: async function (roomkey) {
      this.isSending = true;
      let payload = {
        type: "message",
        room: roomkey,
        message: "Ein neuer Schichtplan wurde bereitgestellt. https://schottappprodshiftplan.z6.web.core.windows.net/redirect",
      };
      await axios.post(
        `${configuration.chatEndpoint}sendMessage.xsjs`,
        payload
      );
      this.isSending = false;
    },
  },
};
</script>